import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "chat" }
const _hoisted_2 = { class: "chat-part" }
const _hoisted_3 = {
  key: 0,
  class: "chat-loading"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatHeader = _resolveComponent("ChatHeader")
  const _component_Loader = _resolveComponent("Loader")
  const _component_AIChat = _resolveComponent("AIChat")
  const _component_ShareModal = _resolveComponent("ShareModal")
  const _component_AddPrompt = _resolveComponent("AddPrompt")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ChatHeader, {
        shared: $options.shared,
        "can-share": $options.can_share,
        generating: $options.generating,
        onShare: $options.share
      }, null, 8 /* PROPS */, ["shared", "can-share", "generating", "onShare"]),
      ($options.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Loader, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Loading chat data"),
                _createElementVNode("br", null, null, -1 /* HOISTED */),
                _createTextVNode(" Please wait... ")
              ])),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      (!$options.loading)
        ? (_openBlock(), _createBlock(_component_AIChat, {
            key: 1,
            ref: "chat",
            class: "chat-container",
            "chat-id": $props.chat.id,
            history: $props.chat.history,
            generating: $options.generating,
            readonly: $options.readonly,
            "ref-history-len": $options.ref_history_len,
            mode: "expanded",
            description: "Genrate can make mistakes. Consider checking important information.",
            onRegenerate: $options.onChat,
            onStop: $options.onStop,
            onAskAi: $options.onChat,
            onLike: _cache[0] || (_cache[0] = ({idx, feedback}) => $data.onLike(idx, feedback)),
            onDislike: _cache[1] || (_cache[1] = ({idx, feedback}) => $data.onDislike(idx, feedback)),
            onSave: _cache[2] || (_cache[2] = ({idx, text}) => $data.onSave(idx, text)),
            onRefrag: _cache[3] || (_cache[3] = ({idx, range}) => $options.onRegenerateFragment(idx, range)),
            onMeetingSave: _cache[4] || (_cache[4] = ({idx}) => $data.onMeetingSave(idx)),
            onPodcastSave: _cache[5] || (_cache[5] = ({idx}) => $data.onPodcastSave(idx)),
            onPromptSave: _cache[6] || (_cache[6] = ({idx}) => $options.onPromptSave(idx))
          }, null, 8 /* PROPS */, ["chat-id", "history", "generating", "readonly", "ref-history-len", "onRegenerate", "onStop", "onAskAi"]))
        : _createCommentVNode("v-if", true),
      ($options.can_share)
        ? (_openBlock(), _createBlock(_component_ShareModal, {
            key: 2,
            ref: "share",
            chat: $props.chat
          }, null, 8 /* PROPS */, ["chat"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_AddPrompt, { ref: "prompts" }, null, 512 /* NEED_PATCH */)
    ])
  ]))
}